import { Component, OnInit, Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Viewing } from '../viewingForm/viewing';
import { PortalLeadsData } from '../viewingForm/portalLeadsData';
import 'rxjs/Rx';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import { ViewingUpdate } from '../viewingForm/viewing-update';

@Injectable()
export class DataService {

    //private _nodeURL = 'http://89.213.252.216:3000/'; // Live
    private _nodeURL = 'https://flinkNode.spicerhaart.co.uk:3000/';
    //private _nodeURL = 'http://89.213.252.215:3000/'; // Staging
    //private _nodeURL = 'http://localhost:3000/'; // Local Dev

    private _postcodeLookupURL = 'https://89.213.252.216/api/address/';
    private _processsEmailEndpoint = 'processSoldValuationEmail';
    private _processsValuationEndpoint = 'processCctSoldValuation';
    private _processsViewingEndpoint = 'processViewing';
    private _convertOfficeIdEndpoint = 'ConvertOfficeIdToOfficeCode';
    private _updateValuationEndpoint = 'updateCctSoldValuation';

    // tslint:disable-next-line:max-line-length
    private _googleMapPlaceEndpoint = 'https://maps.googleapis.com/maps/api/place/nearbysearch/json?location=';
    private _googleMapPlaceParams = '&radius=100&types=real_estate_agency&name=HAART';

    private _googleMapPlaceDetailEndpoint = 'https://maps.googleapis.com/maps/api/place/details/json?placeid=';
   //private _googleKey = '&key=AIzaSyDiIZ2ya9gxA1RkmqF4-CmafrNsNFwe63A';  //expired Aug 2018

   private _googleKey = 'AIzaSyC9x374mMsq2F3Vfc38opeNLJbzKV7fLvs';  // new key aug 2018

    public SESSION_STORAGE_KEY  = 'accessToken';

    constructor(
        private _http: Http
    ) { }

    getTestString() {
        return 'The Test String';
    }

    getGoogleReviewPlace(location: string) {
        return this._http.get(this._nodeURL + 'getGoogleReviewPlace/' + location)
        .map((resp: Response) => {
            return JSON.parse(resp.json());
        })
        .catch(this.handleError);
    }

    getGoogleLatLon(address: string) {
        return this._http.get("https://maps.googleapis.com/maps/api/geocode/json?address=" + address + "&key=AIzaSyB-o9qjxwG-lfLoY7SADJwv9a0_T2mtC4w")
        .map((resp: Response) => {
            return resp.json();
        })
        .catch(this.handleError);
    }

    getGoogleReviewPlaceDetails(placeId: string) {
        return this._http.get(this._nodeURL + 'getGoogleReviewPlaceDetails/' + placeId)
        .map((resp: Response) => {
            return JSON.parse(resp.json());
        })
        .catch(this.handleError);
    }

    getPostcodeLookup(postcode: string) {
        return this._http.get(this._postcodeLookupURL + postcode)
            .map((resp: Response) => {
                return resp.json();
            })
            .catch(this.handleError);
    }

    getPropertyData(propRef: string) {

        return this._http.get(this._nodeURL + 'getSoldPropData/' + propRef)
            .map((resp: Response) => {
                return JSON.parse(resp.json());
            })
            .catch(this.handleError);
    }

    getOfficeCode(officeId: string) {

        return this._http.get(this._nodeURL + this._convertOfficeIdEndpoint + "/" + officeId)
            .map((resp: Response) => {
                return JSON.parse(resp.json());
            })
            .catch(this.handleError);
    }

    processViewing(portalLead: PortalLeadsData) {

        let body = JSON.stringify(portalLead);
        let headers = new Headers({ 'Content-Type' : 'application/json' });
        let options = new RequestOptions({ headers: headers });

        return this._http.post(this._nodeURL + this._processsViewingEndpoint, body, options)
            .map((resp: Response) => {
                return resp.json();
            })
            .catch(this.handleError);
    }


    processValuation(valuationData: Viewing) {

        let body = JSON.stringify(valuationData);
        let headers = new Headers({ 'Content-Type' : 'application/json' });
        let options = new RequestOptions({ headers: headers });

        return this._http.post(this._nodeURL + this._processsValuationEndpoint, body, options)
            .map((resp: Response) => {
                return resp.json();
            })
            .catch(this.handleError);
    }

    updateValuation(valuationData: ViewingUpdate) {

        let body = JSON.stringify(valuationData);
        let headers = new Headers({ 'Content-Type' : 'application/json' });
        let options = new RequestOptions({ headers: headers });

        return this._http.post(this._nodeURL + this._updateValuationEndpoint, body, options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    private extractData(res: Response) {
        const body = res.json();
        return body || { };
    }

    private handleError(error: Response) {
        console.error(error);
        return Observable.throw(error.json().error || 'Server error');
    }
}



// WEBPACK FOOTER //
// D:/FLINK/FlinkViewingPageDec2020/NewLandingPage/src/app/shared/data.service.ts